import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { Link } from "gatsby"
import { router } from "../../../utility/router"
import { PageContext } from "../Page"
import { AllFoldersExcept, OnlyFolders } from "../../utility/Folders"
import { LanguageSelect } from "../../components/LanguageSelect"

import Arrow from '../../../assets/icons/right-arrow-header-mobile.svg'
import ExternalIcon from '../../../assets/icons/external-link.svg'
import PropTypes from "prop-types"
// import classNames from "classnames"

const MobileHeaderPopup = ({ isOpen, currentMenu, changeCurrentMenu, closeMenuFunction = () => { } }) => {
  const [t] = useTranslation("layout")
  const buttonClasses = 'flex items-center w-full text-left text-xs relative -left-2 pl-2'
  const subMenuIsOpen = currentMenu !== ''
  const context = useContext(PageContext)
  const externalIcon = <ExternalIcon className="min-w-[16px] min-h-[16px] stroke-midnight-10 inline-block ml-1 relative bottom-[3px]" />

  const ProductsMenu = () => {
    return <>
      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.productsMenu.psd2Services.title')}</h5>
      </div>
      <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.aisp', context.folder)} title={t('header.productsMenu.psd2Services.aisp')} description={t('header.productsMenu.psd2Services.aispDesc')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.pisp', context.folder)} title={t('header.productsMenu.psd2Services.pisp')} description={t('header.productsMenu.psd2Services.pispDesc')} onClick={closeMenuFunction} />
      <OnlyFolders folders={["it-it"]}>
        <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.fast-scoring', context.folder)} title={t('header.productsMenu.psd2Services.creditRating')} description={t('header.productsMenu.psd2Services.creditRatingDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>
      <OnlyFolders folders={["it-it", "fr-fr"]}>
        <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.personalFinance', context.folder)} title={t('header.productsMenu.psd2Services.personalFinance')} description={t('header.productsMenu.psd2Services.personalFinanceDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>
      <OnlyFolders folders={["it-it"]}>
        <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.bankingAsService', context.folder)} title={t('header.productsMenu.psd2Services.bankingAsService')} description={t('header.productsMenu.psd2Services.bankingAsServiceDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>
      <MobileHeaderPopupSection className="py-1" link={router('products.psd2Services.bankCoverage', context.folder)} title={t('header.productsMenu.psd2Services.bankCoverage')} description={t('header.productsMenu.psd2Services.bankCoverageDesc')} onClick={closeMenuFunction} />

      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.productsMenu.endToEndSolutions.title')}</h5>
      </div>
      <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.financeOrchestration', context.folder)} title={t('header.productsMenu.endToEndSolutions.financeOrchestration')} description={t('header.productsMenu.endToEndSolutions.financeOrchestrationDesc')} onClick={closeMenuFunction} />
      <OnlyFolders folders={["it-it"]}>
        <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.sepa', context.folder)} title={t('header.productsMenu.endToEndSolutions.sepa')} description={t('header.productsMenu.endToEndSolutions.sepaDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>
      <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.paymentGate', context.folder)} title={t('header.productsMenu.endToEndSolutions.paymentGate')} description={t('header.productsMenu.endToEndSolutions.paymentGateDesc')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.riskAnalysis', context.folder)} title={t('header.productsMenu.endToEndSolutions.riskAnalysis')} description={t('header.productsMenu.endToEndSolutions.riskAnalysisDesc')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.guaranteedPayments', context.folder)} title={t('header.productsMenu.endToEndSolutions.guaranteedPayments')} description={t('header.productsMenu.endToEndSolutions.guaranteedPaymentsDesc')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.facilitator', context.folder)} title={t('header.productsMenu.endToEndSolutions.facilitator')} description={t('header.productsMenu.endToEndSolutions.facilitatorDesc')} onClick={closeMenuFunction} />
      <OnlyFolders folders={["it-it", "en-gb"]}>
        <MobileHeaderPopupSection className="py-1" link={router('products.endToEndSolutions.financialSplitPayment', context.folder)} title={t('header.productsMenu.endToEndSolutions.financialSplitPayment')} description={t('header.productsMenu.endToEndSolutions.financialSplitPaymentDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>

      <AllFoldersExcept folders={["es-es"]}>
        <div className="mb-1 mt-3">
          <h5 className="text-blue-10">{t('header.productsMenu.bankingServices.title')}</h5>
        </div>
        <OnlyFolders folders={["it-it"]}>
          <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.businessFinance', context.folder)} title={t('header.productsMenu.bankingServices.businessFinance')} description={t('header.productsMenu.bankingServices.businessFinanceDesc')} onClick={closeMenuFunction} />
          <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.smeBanking', context.folder)} title={t('header.productsMenu.bankingServices.smeBanking')} description={t('header.productsMenu.bankingServices.smeBankingDesc')} onClick={closeMenuFunction} />
        </OnlyFolders>
        <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.lendingPlace', context.folder)} title={t('header.productsMenu.bankingServices.lendingPlace')} description={t('header.productsMenu.bankingServices.lendingPlaceDesc')} onClick={closeMenuFunction} />
        <OnlyFolders folders={["it-it"]}>
          <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.onboarding', context.folder)} title={t('header.productsMenu.bankingServices.onboarding')} description={t('header.productsMenu.bankingServices.onboardingDesc')} onClick={closeMenuFunction} />
          <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.checkIban', context.folder)} title={t('header.productsMenu.bankingServices.checkIban')} description={t('header.productsMenu.bankingServices.checkIbanDesc')} onClick={closeMenuFunction} />
        </OnlyFolders>
        <MobileHeaderPopupSection className="py-1" link={router('products.bankingServices.smartBanking', context.folder)} title={t('header.productsMenu.bankingServices.smartBanking')} description={t('header.productsMenu.bankingServices.smartBankingDesc')} onClick={closeMenuFunction} />
      </AllFoldersExcept>

      <OnlyFolders folders={["it-it"]}>
        <div className="mb-1 mt-3">
          <h5 className="text-blue-10">{t('header.productsMenu.inStoreSolutions.title')}</h5>
        </div>
        <MobileHeaderPopupSection className="py-1" link={router('products.inStoreSolutions.tapToPay', context.folder)} title={t('header.productsMenu.inStoreSolutions.tapToPay')} description={t('header.productsMenu.inStoreSolutions.tapToPayDesc')} onClick={closeMenuFunction} />
        <MobileHeaderPopupSection className="py-1" blank icon={externalIcon} link={router('products.inStoreSolutions.posEasyCommissioni', context.folder, true)} title={t('header.productsMenu.inStoreSolutions.posEasyCommissioni')} description={t('header.productsMenu.inStoreSolutions.posEasyCommissioniDesc')} onClick={closeMenuFunction} />
        <MobileHeaderPopupSection className="py-1" blank icon={externalIcon} link={router('products.inStoreSolutions.posEasyCanone', context.folder, true)} title={t('header.productsMenu.inStoreSolutions.posEasyCanone')} description={t('header.productsMenu.inStoreSolutions.posEasyCanoneDesc')} onClick={closeMenuFunction} />
        <MobileHeaderPopupSection className="py-1" blank icon={externalIcon} link={router('products.inStoreSolutions.payByLink', context.folder, true)} title={t('header.productsMenu.inStoreSolutions.payByLink')} description={t('header.productsMenu.inStoreSolutions.payByLinkDesc')} onClick={closeMenuFunction} />
        <MobileHeaderPopupSection className="py-1" blank icon={externalIcon} link={router('products.inStoreSolutions.digitalizzazioneContante', context.folder, true)} title={t('header.productsMenu.inStoreSolutions.digitalizzazioneContante')} description={t('header.productsMenu.inStoreSolutions.digitalizzazioneContanteDesc')} onClick={closeMenuFunction} />
      </OnlyFolders>

      <div className="mb-10"></div>
    </>
  }

  const InsightsMenu = () => {
    return <>
      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.insightsMenu.title')}</h5>
      </div>
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('insights.articles', context.folder)} title={t('header.insightsMenu.articles')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('insights.whitepaper', context.folder)} title={t('header.insightsMenu.whitepaper')} onClick={closeMenuFunction} />
      {/* <MobileHeaderPopupSection className="py-2" link={router('insights.video', context.folder)} title={t('header.insightsMenu.video')} /> */}
    </>
  }

  const IndustryMenu = () => {
    return <>
      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.industry')}</h5>
      </div>
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.banking', context.folder)} title={t('header.customerStories.banking')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.fashion', context.folder)} title={t('header.customerStories.fashion')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.fintech', context.folder)} title={t('header.customerStories.fintech')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.horeca', context.folder)} title={t('header.customerStories.horeca')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.insurance', context.folder)} title={t('header.customerStories.insurance')} onClick={closeMenuFunction} />
      <OnlyFolders folders={["it-it", "en-gb"]}>
        <MobileHeaderPopupSection className="pt-3 pb-2" link={router('customer-stories.automotive', context.folder)} title={t('header.customerStories.automotive')} onClick={closeMenuFunction} />
      </OnlyFolders>
      <MobileHeaderPopupSection className="py-2" link={router('customer-stories.customer-stories', context.folder)} title={t('header.customerStories.customerStories')} onClick={closeMenuFunction} />
      {/* <MobileHeaderPopupSection className="py-2" link={router('insights.video', context.folder)} title={t('header.insightsMenu.video')} /> */}
    </>
  }

  const DevelopersMenu = () => {
    return <>
      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.devsMenu.title')}</h5>
      </div>
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('developers.api', context.folder)} title={t('header.devsMenu.api')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('developers.fabrick-producers', context.folder)} title={t('header.devsMenu.producers')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('developers.tpp-portal', context.folder)} title={t('header.devsMenu.tpp')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={'https://www.platfr.io/#/platfr/login'} blank title={t('header.devsMenu.consumerPortal')} onClick={closeMenuFunction} />
      {/* <MobileHeaderPopupSection className="py-1" link={router('developers.assistenza-tecnica', context.folder)} title={t('header.devsMenu.support')} description={t('header.devsMenu.supportDesc')} /> */}
    </>
  }

  const AboutFabrickMenu = () => {
    return <>
      <div className="mb-1 mt-3">
        <h5 className="text-blue-10">{t('header.corporate')}</h5>
      </div>
      <MobileHeaderPopupSection className="py-2" link={router('aboutFabrick.ecosystem', context.folder)} blank title={t('header.aboutFabrickMenu.ecosystem')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('aboutFabrick.history', context.folder)} blank title={t('header.aboutFabrickMenu.history')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('aboutFabrick.mission', context.folder)} title={t('header.aboutFabrickMenu.mission')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('aboutFabrick.team', context.folder)} blank title={t('header.aboutFabrickMenu.team')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('aboutFabrick.platform', context.folder)} title={t('header.aboutFabrickMenu.platform')} onClick={closeMenuFunction} />

      <div className="mb-1 mt-4">
        <h5 className="text-blue-10">{t('header.fabrickPeople')}</h5>
      </div>
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('fabrickPeople.ourTeam', context.folder)} title={t('footer.ourTeam')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('fabrickPeople.whyFabrick', context.folder)} title={t('footer.whyFabrick')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('fabrickPeople.joinUs', context.folder)} blank title={t('footer.openPositions')} onClick={closeMenuFunction} />

      <div className="mb-1 mt-4">
        <h5 className="text-blue-10">{t('header.mediaHub')}</h5>
      </div>
      <MobileHeaderPopupSection className="pt-3 pb-2" link={router('mediaHub.pressReleases', context.folder)} title={t('header.pressReleases')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('mediaHub.pressReview', context.folder)} title={t('header.pressReview')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('mediaHub.events', context.folder)} blank title={t('header.events')} onClick={closeMenuFunction} />
      <MobileHeaderPopupSection className="py-2" link={router('mediaHub.mediaKit', context.folder)} blank title={t('header.mediaKit')} onClick={closeMenuFunction} />
    </>
  }

  // const SupportMenu = () => {
  //   return <>
  //     <div className="mb-1 mt-3">
  //       <h5 className="text-blue-10">{t('header.supportMenu.title')}</h5>
  //     </div>
  //     <MobileHeaderPopupSection className="pt-3 pb-2" link='https://developers.fabrick.com' blank={true} title={t('header.supportMenu.faq')} />
  //     <MobileHeaderPopupSection className="py-2" link={router('support.customer-support', context.folder)} title={t('header.supportMenu.support')} />
  //   </>
  // }

  return <div style={{ transform: 'translateZ(-10px)' }} className={`mobile-menu ${isOpen ? 'open' : ''} ${subMenuIsOpen ? 'ml-[-100%]' : ''} w-[200%] h-[calc(100vh-theme(height.header))] absolute top-[100%] left-0 bg-white`}>
    <div className={`${subMenuIsOpen ? 'opacity-0' : ''} w-1/2 h-full px-container-mobile md:px-container-desktop transition-all ${isOpen ? 'overflow-y-auto' : ''}`}>
      <button onClick={() => changeCurrentMenu('products')} className={`${buttonClasses} py-2 mt-1`}>
        {t('header.products')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button>

      <button onClick={() => changeCurrentMenu('industry')} className={`${buttonClasses} py-2`}>
        {t('header.industry')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button>

      <button onClick={() => changeCurrentMenu('insights')} className={`${buttonClasses} py-2`}>
        {t('header.insights')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button>

      <button onClick={() => changeCurrentMenu('developers')} className={`${buttonClasses} py-2`}>
        {t('header.developers')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button>

      {/* <button onClick={() => changeCurrentMenu('support')} className={`${buttonClasses} py-2`}>
        {t('header.support')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button> */}
      <Link to={router('support.customer-support', context.folder)} className="text-link-unstyled" onClick={closeMenuFunction}>
        <button className={`${buttonClasses} py-2`}>
          {t('header.support')}
        </button>
      </Link>

      <button onClick={() => changeCurrentMenu('about-fabrick')} className={`${buttonClasses} py-2`}>
        {t('header.aboutFabrick')}<Arrow className="inline stroke-midnight-10 ml-0.5" />
      </button>

      <Link to={router('contacts', context.folder)} className="text-link-unstyled" onClick={closeMenuFunction}>
        <button className={`${buttonClasses} py-2`}>
          {t('header.contacts')}
        </button>
      </Link>

      <Link to={router('login', context.folder)} className="text-link-unstyled" onClick={closeMenuFunction}>
        <button className={`${buttonClasses} py-2`}>
          {t('header.login')}
        </button>
      </Link>

      <div className="mt-2 mb-20">
        <LanguageSelect negative={false} mobile={true} />
      </div>
    </div>
    <div className={`${subMenuIsOpen ? '' : 'opacity-0'} w-1/2 h-full px-container-mobile md:px-container-desktop absolute top-0 left-1/2 transition-all ${isOpen ? 'overflow-y-auto' : ''}`}>
      <div className={`transition-all absolute ${currentMenu === 'products' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <ProductsMenu />
      </div>

      <div className={`transition-all absolute ${currentMenu === 'industry' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <IndustryMenu />
      </div>

      <div className={`transition-all absolute ${currentMenu === 'insights' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <InsightsMenu />
      </div>

      <div className={`transition-all absolute ${currentMenu === 'developers' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <DevelopersMenu />
      </div>

      <div className={`transition-all absolute ${currentMenu === 'about-fabrick' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <AboutFabrickMenu />
      </div>

      {/* <div className={`transition-all absolute ${currentMenu === 'support' ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
        <SupportMenu />
      </div> */}
    </div>
  </div>
}

export const MobileHeaderPopupSection = ({ link, title, description, className = '', onClick = () => { }, blank = false, icon = undefined }) => {
  const hasDescription = description && description !== ''

  return <Link to={link} className="text-link-unstyled" target={`${blank ? '_blank' : '_self'}`} onClick={onClick} {...(blank ? { rel: 'noopener' } : {})}>
    <div className={`${className}`}>
      <div className={`${hasDescription ? 'text-body' : 'text-xs'}`}>
        <strong className="text-midnight-10">{title}</strong>
        {icon !== undefined && icon}
      </div>
      {hasDescription && <div className="text-small">
        {description}
      </div>}
    </div>
  </Link>
}

MobileHeaderPopupSection.propTypes = {
  link: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.element,
  blank: PropTypes.bool,
  onClick: PropTypes.func
}

export default MobileHeaderPopup